/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ThreadIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB60lEQVR4nLWUy2oUURBAR1DBF+4UI0bdiQHxsfEFs9BskluPO1BdNZMsXM1K9BPUuDb+gIIu/AclP5FEXPjY6c5sNTAhKHU7rW0zk9hJT0NDc/t2nTq3q6rVqnkB2EkiPdcaxzU7K6eR9TuQ/UTM7jYOQJSLQDpAtl9jgRDpGSD96oCxQJDsfRF8LBAke1cF7BkyPT1/JMa5U/7cbrf3A+ljZNtoDAJsb4B0E1gXReSQrwXu3gCyL41AgPReqXI+Qie75euIeAxIX+4KkqqFrdvv9w+kjGN2FVlX8gC6CWTPChtg7QDpWi0IsL1Om8mWEe2Kr4nIQWRbKNsQ6c3cxiaqBeCQmU7v7N8GYl0EsKncoHcZST9tZTwAsicO2MFmH7I+RNL1rXdrPlbSbPH2zzPWdYz2wDeHEA4j63MPkmelKx58lA2AXUr2YFPlZFuukc6srMf6tijNwN3b/9ro02E2SPpq5Jn7D6lCkhVaTIEqNsC6yty79scmZnMhyOS2lTMcYn6/EJGjVRtvNmC9v23QGpDPELPrhU0649R8tlQLkAKQ3hkB2UC2Rz4ufB+AnBeR47UBBQTZfgwbbF7vuwr6vxBg+9AIYATk247VshcIkA5Cp3uhUUAZkoYa2kTjgAQJMhnj/Im6H/4GVj2G0BJR7RgAAAAASUVORK5CYII=)
 */
export const ThreadIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        d="M12 2.81a1 1 0 0 1 0-1.41l.36-.36a1 1 0 0 1 1.41 0l9.2 9.2a1 1 0 0 1 0 1.4l-.7.7a1 1 0 0 1-1.3.13l-9.54-6.72a1 1 0 0 1-.08-1.58l1-1L12 2.8ZM12 21.2a1 1 0 0 1 0 1.41l-.35.35a1 1 0 0 1-1.41 0l-9.2-9.19a1 1 0 0 1 0-1.41l.7-.7a1 1 0 0 1 1.3-.12l9.54 6.72a1 1 0 0 1 .07 1.58l-1 1 .35.36ZM15.66 16.8a1 1 0 0 1-1.38.28l-8.49-5.66A1 1 0 1 1 6.9 9.76l8.49 5.65a1 1 0 0 1 .27 1.39ZM17.1 14.25a1 1 0 1 0 1.11-1.66L9.73 6.93a1 1 0 0 0-1.11 1.66l8.49 5.66Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
